import ButtonIcon from "components/ButtonIcon/ButtonIcon";
import { Tooltip } from "components/Tooltip/Tooltip";
import { useState } from "react";
import { useSelector } from "utils/redux";

import GenerateAllocatorNotesModal from "./GenerateAllocatorNotesModal";

type GenerateAllocatorNotesButtonProps = {
  serviceId: string;
  serviceType: "MSA" | "LCP" | "MCP" | "AMENDED_REVIEW" | "DOCS";
};

const GenerateAllocatorNotesButton = ({
  serviceId,
  serviceType,
}: GenerateAllocatorNotesButtonProps) => {
  const [showModal, setShowModal] = useState(false);
  const loggedInUser = useSelector((state) => state.main.loggedInUser);
  const hasPermission =
    loggedInUser?.has_ai_summary_authority ||
    loggedInUser?.is_staff ||
    loggedInUser?.is_superuser;
  return (
    <>
      <Tooltip content={"AI Document Analysis"}>
        <ButtonIcon
          kind="neutral"
          onClick={() => setShowModal(true)}
          aria-label={"AI Document Analysis"}
          disabled={!hasPermission}
        >
          note_alt
        </ButtonIcon>
      </Tooltip>

      <GenerateAllocatorNotesModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        serviceId={serviceId}
        serviceType={serviceType}
      />
    </>
  );
};

export default GenerateAllocatorNotesButton;
